{
  "info": "Инфо",
  "negative": "Грешка",
  "positive": "Успех"
}
